import React from 'react';
import TopNavigation from './TopNavigation';
import './BaseLayout.css';

const BaseLayout = ({ 
  onBack, 
  onLogout, 
  title, 
  headerActions,
  children,
  className = ""
}) => {
  return (
    <div className={`base-layout ${className}`}>
      <TopNavigation onBack={onBack} onLogout={onLogout} />
      
      <div className="base-content">
        <header className="base-header">
          <div className="header-left">
            <h1>{title}</h1>
          </div>
          <div className="header-actions">
            {headerActions}
          </div>
        </header>
        
        <div className="base-main">
          {children}
        </div>
      </div>
    </div>
  );
};

export default BaseLayout;